import { Button } from "@mantine/core";
import { useState } from "react";

import { ProductListPopover, type ListedProduct } from "../../../platform/media/ProductListPopover";
import classes from "./ad-copies.module.css";

export interface ProductFieldProps {
  teamId: string;
  brandId: string;
  product: ListedProduct | null;
  disabled: boolean;
  onPick: (product: ListedProduct) => void;
}

/**
 * Live's "Select product" field of the ad copy forms (`ProductSelectPopover`, captures
 * advanced-234/05 to 07): the product's photo and "Change", or an empty picture and "Add product";
 * either opens live's one-product list beside it.
 */
export function ProductField({ teamId, brandId, product, disabled, onPick }: ProductFieldProps) {
  const [opened, setOpened] = useState(false);
  return (
    <div className={classes.productField}>
      {product?.url == null ? (
        <span className={classes.productPicture} aria-hidden />
      ) : (
        <img src={product.url} alt={product.name} className={classes.productPicture} />
      )}
      <ProductListPopover
        teamId={teamId}
        brandId={brandId}
        chosenId={product?.productId ?? null}
        opened={opened}
        onClose={() => setOpened(false)}
        onPick={onPick}
        anchor={(wrap) =>
          wrap(
            <Button
              variant="default"
              disabled={disabled}
              onClick={() => setOpened((open) => !open)}
            >
              {product === null ? "Add product" : "Change"}
            </Button>,
          )
        }
      />
    </div>
  );
}
